import Web3 from "web3";

let web3;

if (window.ethereum) {
  web3 = new Web3(window.ethereum);
  try {
    window.ethereum.enable(); // Request access to MetaMask accounts
  } catch (error) {
    console.error("User denied account access");
  }
} else if (window.web3) {
  web3 = new Web3(window.web3.currentProvider);
} else {
  alert("Non-Ethereum browser detected. You should consider trying MetaMask!");
}

const getCurrentAccount = async () => {
  const accounts = await web3.eth.getAccounts();
  return accounts[0];
};

export { web3, getCurrentAccount };
